export default "__VITE_ASSET__DZJH5J06__"